/**
 * 模板卡预览策略（互斥槽位 + hover intent）：
 * - 全局互斥：任意时刻只允许一块卡片占用网络加载预览。
 * - hover intent：指针停留满 {@link TEMPLATE_PREVIEW_HOVER_INTENT_MS} 且封面就绪后才 `take` + 挂 `src`，
 *   快速划过时不会起定时器任务（本质是对「开始预览」做 debounce，而非对事件节流）。
 */
export const TEMPLATE_PREVIEW_HOVER_INTENT_MS = 220;

type PreviewCleanup = () => void;

let activeCleanup: PreviewCleanup | null = null;

/** 抢占预览槽位；若已有其它卡片占用，会先执行其 teardown。已是当前拥有者则不再重复抢占（避免 effect 重跑时自我打断） */
export function takeTemplatePreviewSlot(teardownWhenPreempted: PreviewCleanup): void {
  if (activeCleanup === teardownWhenPreempted) {
    return;
  }
  activeCleanup?.();
  activeCleanup = teardownWhenPreempted;
}

/**
 * 鼠标离开当前卡或卸载时调用：若仍是槽位拥有者，则清空全局引用，并始终执行本卡本地清理
 */
export function releaseTemplatePreviewSlot(teardownWhenPreempted: PreviewCleanup): void {
  if (activeCleanup === teardownWhenPreempted) {
    activeCleanup = null;
  }
  teardownWhenPreempted();
}
